import React from 'react';
import { motion } from 'framer-motion';
const course = {
  id: 'owd',
  title: 'OPEN WATER DIVER',
  image: 'https://cdn.magicpatterns.com/uploads/nhp9DKFQwUKJpi5mCbdrrM/WhatsApp_Image_2026-06-12_at_04.26.41.jpg',
  href: 'https://openwaterdiver.buceoynavegacion.com'
};
export function Training() {
  return <section id="courses" className="py-24 md:py-32 bg-zinc-950 text-white overflow-hidden" data-id="element-75" data-mp="2lwz87cail5vq">
      <div className="px-6 md:px-12 max-w-7xl mx-auto mb-12 md:mb-16" data-id="element-76" data-mp="2zwh1a3uuf5aw">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-77" data-mp="2vwq2pdz2rkvt">
          <span className="text-blue-400/80 font-mono text-[10px] md:text-xs uppercase tracking-[0.25em] block mb-4" data-id="element-78" data-mp="3jm0y0fxnon2k">
            Formación
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold uppercase tracking-tight mb-6" data-id="element-79" data-mp="2oftpvw64leoq">
            El comienzo de todo
          </h2>
          <p className="text-zinc-400 text-lg md:text-xl font-light max-w-2xl" data-id="element-80" data-mp="2tghekb6vtjfs">
            "Antes de descubrir el mundo, aprendemos a explorarlo."
          </p>
        </motion.div>
      </div>

      {/* Single featured course card */}
      <div className="px-6 md:px-12 max-w-5xl mx-auto" data-id="element-81" data-mp="37eo330pxy72s">
        <motion.a href={course.href} target="_blank" rel="noopener noreferrer" aria-label={course.title} initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.9,
        ease: 'easeOut'
      }} className="group relative block w-full aspect-square sm:aspect-[4/3] md:aspect-[16/10] rounded-2xl md:rounded-3xl overflow-hidden bg-zinc-900 shadow-2xl" data-id="element-82" data-mp="37c1tywnejjig">
          <img src={course.image} alt={course.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" data-id="element-83" data-mp="1q3fpbtcqrlzp" />
          {/* Subtle overlay shift on hover; artwork already carries its title */}
          <div className="absolute inset-0 bg-black/0 transition-colors duration-700 group-hover:bg-black/10" data-id="element-84" data-mp="2dqnt26uiumzm" />
        </motion.a>
      </div>
    </section>;
}